import { jsx } from "react/jsx-runtime";
import React from "react";
var shopping_bag_trolley_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "m7.0641 3 2.3655 15.6121a1.497 1.497 0 0 1 .57-.1121c.8285 0 1.5001.6716 1.5001 1.5h5.5002v-2h-5.6402L9.087 3H7.064z" }), /* @__PURE__ */ jsx("path", { d: "M9.9997 21c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" })];
};
export {
  shopping_bag_trolley_default as default
};
